import React, { useContext } from 'react';
import { StyledMenu } from './Menu.styled';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { getListEnvTopNavWeb } from '../../../api/envTopNavWeb';
import { validURL } from '../../../utils/utils';
import RenderSvgIcon from '../../RenderSvgIcon';
import { DISPLAY_ELEMENT_TYPE } from '../../../config/constants';
import { AuthContext } from '../../../context/AuthContext';

const Menu = ({ open, envUi, ...props }) => {
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const userProfile = authContext.userProfile;
  const { data: envTopNavWebs } = useQuery(['getListEnvTopNavWeb'], getListEnvTopNavWeb, { cacheTime: Infinity });

  const isHidden = !!open;
  const tabIndex = isHidden ? 0 : -1;

  if (!envTopNavWebs || !userProfile) {
    return null;
  }

  const handleCheckPath = (path) => {
    history.push({ pathname: path });
    props?.setOpen(false);
  };

  const renderIconMenu = (iconPath) => {
    let src = '';
    try {
      // Link public
      if (validURL(iconPath)) {
        return <img src={iconPath} alt="" />;
      }

      const str = `${iconPath}`.split('\\').join('/').split('/');

      if (str && str.length && str[str.length - 1].includes('.')) {
        if (str[str.length - 1].toLowerCase().includes('.svg')) {
          return (
            <RenderSvgIcon
              name={str[str.length - 1].split('.')[0]}
              fill="var(--sub-color)"
              style={{ fill: 'currentColor' }}
              className={'d-svg'}
            />
          );
        }
        // Other .png
        src = require(`assets/image-icon/${str[str.length - 1]}`); // Fix name `assets/image-icon` not use params form db
      }
    } catch (e) {}

    return <img src={src} alt="" />;
  };

  const renderContentLink = (context) => {
    let ctxLink = context.link;

    if (context && context?.link === `${process.env.RAZZLE_PUBLIC_URL}/mypage`) {
      ctxLink =
        userProfile?.gender === 2
          ? `${process.env.RAZZLE_PUBLIC_URL}/mypagefemale`
          : `${process.env.RAZZLE_PUBLIC_URL}/mypagemale`;
    }

    if (context && context?.link === 'mypage-job') {
      ctxLink =
        userProfile?.gender === 2
          ? `${process.env.RAZZLE_PUBLIC_URL}/mypagefemale-job`
          : `${process.env.RAZZLE_PUBLIC_URL}/mypagemale-job`;
    }

    return ctxLink;
  };

  return (
    <StyledMenu open={open} aria-hidden={!isHidden} {...props} className={'d-menu-wrapper'}>
      <ul>
        {(envTopNavWebs?.data || []).map((ele, index) => {
          // Hidden
          if (+ele.displaySetting !== DISPLAY_ELEMENT_TYPE.ON) {
            return null;
          }
          return (
            <li tabIndex={tabIndex} key={index} onClick={() => handleCheckPath(renderContentLink(ele))}>
              {renderIconMenu(ele?.iconImage)}
              <span className="font-4">{ele.content}</span>
            </li>
          );
        })}
      </ul>
    </StyledMenu>
  );
};

export default Menu;
